import { render } from "./CostStandardsHolder.vue?vue&type=template&id=e37b3752&scoped=true&ts=true"
import script from "./CostStandardsHolder.vue?vue&type=script&lang=ts"
export * from "./CostStandardsHolder.vue?vue&type=script&lang=ts"

import "./CostStandardsHolder.vue?vue&type=style&index=0&id=e37b3752&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e37b3752"]])

export default __exports__